import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56492b80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "franchise-application-section ptb-100",
  id: "contact"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-5\" data-v-56492b80><div class=\"franchise-info\" data-v-56492b80><div class=\"section-header\" data-v-56492b80><span class=\"badge\" data-v-56492b80>Start Your Journey</span><h2 data-v-56492b80>Join Our Growing Family</h2><p data-v-56492b80>Take the first step toward owning your own Guac &amp; Grill restaurant. Our streamlined application process makes it easy to get started.</p></div><div class=\"benefits-grid\" data-v-56492b80><div class=\"benefit-card\" data-v-56492b80><div class=\"benefit-icon\" data-v-56492b80><i class=\"ri-trophy-line\" data-v-56492b80></i></div><div class=\"benefit-content\" data-v-56492b80><h4 data-v-56492b80>Proven Success</h4><p data-v-56492b80>Join a brand with strong ROI and proven business model</p></div></div><div class=\"benefit-card\" data-v-56492b80><div class=\"benefit-icon\" data-v-56492b80><i class=\"ri-graduation-cap-line\" data-v-56492b80></i></div><div class=\"benefit-content\" data-v-56492b80><h4 data-v-56492b80>Complete Training</h4><p data-v-56492b80>Comprehensive training program and ongoing support</p></div></div><div class=\"benefit-card\" data-v-56492b80><div class=\"benefit-icon\" data-v-56492b80><i class=\"ri-rocket-line\" data-v-56492b80></i></div><div class=\"benefit-content\" data-v-56492b80><h4 data-v-56492b80>Marketing Support</h4><p data-v-56492b80>Full marketing and operational assistance included</p></div></div></div><div class=\"contact-info-card\" data-v-56492b80><h4 data-v-56492b80>Need Help?</h4><p data-v-56492b80>Our franchise team is here to answer your questions</p><div class=\"contact-methods\" data-v-56492b80><a href=\"mailto:info@guacngrill.com\" class=\"contact-method\" data-v-56492b80><i class=\"ri-mail-line\" data-v-56492b80></i><span data-v-56492b80>info@guacngrill.com</span></a></div></div></div></div>", 1)
const _hoisted_5 = { class: "col-lg-7" }
const _hoisted_6 = { class: "application-form-container" }
const _hoisted_7 = { class: "form-progress" }
const _hoisted_8 = { class: "progress-steps" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Personal Info", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "3", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Investment", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "4", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Submit", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "progress-bar" }
const _hoisted_22 = { class: "form-step" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Personal Information"),
  /*#__PURE__*/_createElementVNode("p", null, "Tell us about yourself to get started")
], -1))
const _hoisted_24 = { class: "form-grid" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "First Name *", -1))
const _hoisted_27 = {
  key: 0,
  class: "error-text"
}
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Last Name *", -1))
const _hoisted_30 = {
  key: 0,
  class: "error-text"
}
const _hoisted_31 = { class: "input-group full-width" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email Address *", -1))
const _hoisted_33 = {
  key: 0,
  class: "error-text"
}
const _hoisted_34 = { class: "input-group full-width" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone Number *", -1))
const _hoisted_36 = {
  key: 0,
  class: "error-text"
}
const _hoisted_37 = { class: "input-group full-width" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "Preferred Location *", -1))
const _hoisted_39 = {
  key: 0,
  class: "error-text"
}
const _hoisted_40 = { class: "step-actions" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1))
const _hoisted_42 = { class: "form-step" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Your Experience"),
  /*#__PURE__*/_createElementVNode("p", null, "Help us understand your background")
], -1))
const _hoisted_44 = { class: "form-grid" }
const _hoisted_45 = { class: "input-group full-width" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "experience" }, "Restaurant Experience *", -1))
const _hoisted_47 = { class: "select-wrapper" }
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-56492b80>Select your experience level</option><option value=\"none\" data-v-56492b80>No Restaurant Experience</option><option value=\"1-3\" data-v-56492b80>1-3 Years Experience</option><option value=\"3-5\" data-v-56492b80>3-5 Years Experience</option><option value=\"5-10\" data-v-56492b80>5-10 Years Experience</option><option value=\"10+\" data-v-56492b80>10+ Years Experience</option>", 6)
const _hoisted_54 = [
  _hoisted_48
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1))
const _hoisted_56 = {
  key: 0,
  class: "error-text"
}
const _hoisted_57 = { class: "input-group full-width" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Why Guac & Grill?", -1))
const _hoisted_59 = { class: "step-actions" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1))
const _hoisted_62 = { class: "form-step" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Investment Details"),
  /*#__PURE__*/_createElementVNode("p", null, "Let's discuss your investment capacity")
], -1))
const _hoisted_64 = { class: "form-grid" }
const _hoisted_65 = { class: "input-group full-width" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "investment" }, "Available Investment *", -1))
const _hoisted_67 = { class: "select-wrapper" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-56492b80>Select your investment range</option><option value=\"250k-500k\" data-v-56492b80>$250,000 - $500,000</option><option value=\"500k-750k\" data-v-56492b80>$500,000 - $750,000</option><option value=\"750k-1m\" data-v-56492b80>$750,000 - $1,000,000</option><option value=\"1m-1.5m\" data-v-56492b80>$1,000,000 - $1,500,000</option><option value=\"1.5m+\" data-v-56492b80>$1,500,000+</option>", 6)
const _hoisted_74 = [
  _hoisted_68
]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1))
const _hoisted_76 = {
  key: 0,
  class: "error-text"
}
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<div class=\"investment-info\" data-v-56492b80><div class=\"info-card\" data-v-56492b80><h4 data-v-56492b80>Investment Breakdown</h4><ul data-v-56492b80><li data-v-56492b80><span data-v-56492b80>Initial Franchise Fee:</span> <strong data-v-56492b80>$45,000</strong></li><li data-v-56492b80><span data-v-56492b80>Equipment &amp; Setup:</span> <strong data-v-56492b80>$150,000 - $250,000</strong></li><li data-v-56492b80><span data-v-56492b80>Working Capital:</span> <strong data-v-56492b80>$50,000 - $100,000</strong></li><li data-v-56492b80><span data-v-56492b80>Marketing Launch:</span> <strong data-v-56492b80>$15,000 - $25,000</strong></li></ul></div></div>", 1)
const _hoisted_78 = { class: "step-actions" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1))
const _hoisted_81 = { class: "form-step" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Review & Submit"),
  /*#__PURE__*/_createElementVNode("p", null, "Please review your information before submitting")
], -1))
const _hoisted_83 = { class: "review-section" }
const _hoisted_84 = { class: "review-card" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Personal Information", -1))
const _hoisted_86 = { class: "review-grid" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email:", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Phone:", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Location:", -1))
const _hoisted_91 = { class: "review-card" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Experience & Interest", -1))
const _hoisted_93 = { class: "review-grid" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Experience:", -1))
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Message:", -1))
const _hoisted_97 = { class: "review-card" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Investment", -1))
const _hoisted_99 = { class: "review-grid" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Range:", -1))
const _hoisted_101 = { class: "terms-section" }
const _hoisted_102 = { class: "checkbox-container" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, [
  /*#__PURE__*/_createTextVNode(" I agree to be contacted by Guac & Grill franchise team and accept the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/terms-conditions",
    target: "_blank"
  }, "terms & conditions"),
  /*#__PURE__*/_createTextVNode(" * ")
], -1))
const _hoisted_105 = {
  key: 0,
  class: "error-text"
}
const _hoisted_106 = { class: "step-actions" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1))
const _hoisted_108 = ["disabled"]
const _hoisted_109 = { key: 0 }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-send-plane-line" }, null, -1))
const _hoisted_111 = { key: 1 }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-loader-4-line spinning" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(['step', { active: _ctx.currentStep >= 1, completed: _ctx.currentStep > 1 }])
                }, _hoisted_11, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['step', { active: _ctx.currentStep >= 2, completed: _ctx.currentStep > 2 }])
                }, _hoisted_14, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['step', { active: _ctx.currentStep >= 3, completed: _ctx.currentStep > 3 }])
                }, _hoisted_17, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(['step', { active: _ctx.currentStep >= 4 }])
                }, _hoisted_20, 2)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "progress-fill",
                  style: _normalizeStyle({ width: _ctx.progressPercentage + '%' })
                }, null, 4)
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
              class: "modern-franchise-form"
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
                      type: "text",
                      id: "firstName",
                      class: _normalizeClass({ error: _ctx.errors.firstName }),
                      placeholder: "Enter your first name"
                    }, null, 2), [
                      [_vModelText, _ctx.form.firstName]
                    ]),
                    (_ctx.errors.firstName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.errors.firstName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
                      type: "text",
                      id: "lastName",
                      class: _normalizeClass({ error: _ctx.errors.lastName }),
                      placeholder: "Enter your last name"
                    }, null, 2), [
                      [_vModelText, _ctx.form.lastName]
                    ]),
                    (_ctx.errors.lastName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.errors.lastName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                      type: "email",
                      id: "email",
                      class: _normalizeClass({ error: _ctx.errors.email }),
                      placeholder: "your.email@example.com"
                    }, null, 2), [
                      [_vModelText, _ctx.form.email]
                    ]),
                    (_ctx.errors.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.errors.email), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.phone) = $event)),
                      type: "tel",
                      id: "phone",
                      class: _normalizeClass({ error: _ctx.errors.phone }),
                      placeholder: "+1 (555) 123-4567"
                    }, null, 2), [
                      [_vModelText, _ctx.form.phone]
                    ]),
                    (_ctx.errors.phone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.errors.phone), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.city) = $event)),
                      type: "text",
                      id: "city",
                      class: _normalizeClass({ error: _ctx.errors.city }),
                      placeholder: "City, State where you'd like to open"
                    }, null, 2), [
                      [_vModelText, _ctx.form.city]
                    ]),
                    (_ctx.errors.city)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.errors.city), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                    class: "btn-next"
                  }, [
                    _createTextVNode(" Continue "),
                    _hoisted_41
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.currentStep === 1]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.experience) = $event)),
                        id: "experience",
                        class: _normalizeClass({ error: _ctx.errors.experience })
                      }, _hoisted_54, 2), [
                        [_vModelSelect, _ctx.form.experience]
                      ]),
                      _hoisted_55
                    ]),
                    (_ctx.errors.experience)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.errors.experience), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.message) = $event)),
                      id: "message",
                      rows: "4",
                      placeholder: "Tell us why you're interested in a Guac & Grill franchise..."
                    }, null, 512), [
                      [_vModelText, _ctx.form.message]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args))),
                    class: "btn-prev"
                  }, [
                    _hoisted_60,
                    _createTextVNode(" Back ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                    class: "btn-next"
                  }, [
                    _createTextVNode(" Continue "),
                    _hoisted_61
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.currentStep === 2]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.investment) = $event)),
                        id: "investment",
                        class: _normalizeClass({ error: _ctx.errors.investment })
                      }, _hoisted_74, 2), [
                        [_vModelSelect, _ctx.form.investment]
                      ]),
                      _hoisted_75
                    ]),
                    (_ctx.errors.investment)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.errors.investment), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_77
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args))),
                    class: "btn-prev"
                  }, [
                    _hoisted_79,
                    _createTextVNode(" Back ")
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                    class: "btn-next"
                  }, [
                    _createTextVNode(" Continue "),
                    _hoisted_80
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.currentStep === 3]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _hoisted_85,
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("div", null, [
                        _hoisted_87,
                        _createTextVNode(" " + _toDisplayString(_ctx.form.firstName) + " " + _toDisplayString(_ctx.form.lastName), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_88,
                        _createTextVNode(" " + _toDisplayString(_ctx.form.email), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_89,
                        _createTextVNode(" " + _toDisplayString(_ctx.form.phone), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_90,
                        _createTextVNode(" " + _toDisplayString(_ctx.form.city), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentStep = 1)),
                      class: "edit-btn"
                    }, "Edit")
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", null, [
                        _hoisted_94,
                        _createTextVNode(" " + _toDisplayString(_ctx.getExperienceLabel(_ctx.form.experience)), 1)
                      ]),
                      (_ctx.form.message)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _hoisted_96,
                            _createTextVNode(" " + _toDisplayString(_ctx.form.message), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentStep = 2)),
                      class: "edit-btn"
                    }, "Edit")
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _hoisted_98,
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", null, [
                        _hoisted_100,
                        _createTextVNode(" " + _toDisplayString(_ctx.getInvestmentLabel(_ctx.form.investment)), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentStep = 3)),
                      class: "edit-btn"
                    }, "Edit")
                  ])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("label", _hoisted_102, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.agreeTerms) = $event)),
                      type: "checkbox",
                      required: ""
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.agreeTerms]
                    ]),
                    _hoisted_103,
                    _hoisted_104
                  ]),
                  (_ctx.errors.agreeTerms)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_ctx.errors.agreeTerms), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args))),
                    class: "btn-prev"
                  }, [
                    _hoisted_107,
                    _createTextVNode(" Back ")
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _ctx.isSubmitting,
                    class: "btn-submit"
                  }, [
                    (!_ctx.isSubmitting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
                          _hoisted_110,
                          _createTextVNode(" Submit Application ")
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_111, [
                          _hoisted_112,
                          _createTextVNode(" Submitting... ")
                        ]))
                  ], 8, _hoisted_108)
                ])
              ], 512), [
                [_vShow, _ctx.currentStep === 4]
              ]),
              (_ctx.submitMessage.type)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['submit-message', _ctx.submitMessage.type])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.submitMessage.type === 'success' ? 'ri-check-line' : 'ri-error-warning-line')
                    }, null, 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.submitMessage.type === 'success' ? 'Application Submitted!' : 'Submission Error'), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.submitMessage.text), 1)
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}